var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-layout"},[(_vm.title)?_c('h5',{staticClass:"card-title"},[_vm._v(_vm._s(_vm.title))]):_vm._e(),_c('div',{staticClass:"card-content",domProps:{"innerHTML":_vm._s(_vm.content)}}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }